import axiosClient from "@/api/common/axiosClient.ts";
import { PrizeCompetition } from "@/types/lottery.ts";

export const getLatestPrizeCompetition = () => {
  return axiosClient.get<PrizeCompetition>(
    "lotteries/latest_prize_competition/",
  );
};
